import mustache from "mustache";
import { IPage } from "../../shared/components/definitions/page/IPage";
import { ClimaDistribucionPrecipitacionRender } from "../../shared/components/modulos/clima/ClimaDistribucionPrecipitacionRender";
import { ClimaEvapotranspiracionHumedadChartRender } from "../../shared/components/modulos/clima/ClimaEvapotranspiracionHumedadChartRender";
import { ClimaHeaderRender } from "../../shared/components/modulos/clima/ClimaHeaderRender";
import { ClimaHorarioStatsRender } from "../../shared/components/modulos/clima/ClimaHorarioStatsRender";
import { ClimaSolSueloRender } from "../../shared/components/modulos/clima/ClimaSolSueloRender";
import { ClimaTemperaturaPrecipitacionChartRender } from "../../shared/components/modulos/clima/ClimaTemperaturaPrecipitacionChartRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_FINCA } from "../components/ClienteAsideMenuRender";
import template from "./climaCurrentTemplate.html";

mustache.parse(template);

/** Página de clima actual (condiciones de hoy) de la finca activa. En
 *  construcción: se arma sección por sección (separadas con <hr class="sx-divider">). */
export class ClimaCurrentPage implements IPage {
  private _header: ClimaHeaderRender | null = null;
  private _stats: ClimaHorarioStatsRender | null = null;
  private _chart: ClimaTemperaturaPrecipitacionChartRender | null = null;
  private _distribucion: ClimaDistribucionPrecipitacionRender | null = null;
  private _solSuelo: ClimaSolSueloRender | null = null;
  private _evapotranspiracion: ClimaEvapotranspiracionHumedadChartRender | null =
    null;

  render(pageContent: HTMLDivElement): void {
    this._header = new ClimaHeaderRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA),
      "horario",
    );
    this._stats = new ClimaHorarioStatsRender();
    this._chart = new ClimaTemperaturaPrecipitacionChartRender();
    this._distribucion = new ClimaDistribucionPrecipitacionRender();
    this._solSuelo = new ClimaSolSueloRender();
    this._evapotranspiracion = new ClimaEvapotranspiracionHumedadChartRender();

    pageContent.innerHTML = mustache.render(template, {
      header: this._header.render(),
      stats: this._stats.render(),
      chart: this._chart.render(),
      distribucion: this._distribucion.render(),
      solSuelo: this._solSuelo.render(),
      evapotranspiracion: this._evapotranspiracion.render(),
    });

    this._header.connect();
    this._stats.connect();
    this._chart.connect();
    this._distribucion.connect();
    this._solSuelo.connect();
    this._evapotranspiracion.connect();
  }

  dispose(): void {
    this._header?.dispose();
    this._stats?.dispose();
    this._chart?.dispose();
    this._distribucion?.dispose();
    this._solSuelo?.dispose();
    this._evapotranspiracion?.dispose();
  }
}
